// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as UseSafeTimeout from "../../../../node_modules/@makerinc/use-safe-timeout/lib/es6_global/src/UseSafeTimeout.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as ProductPin$Showside from "./ProductPin.bs.js";
import * as ObjectFitMath$Showside from "../utils/ObjectFitMath.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as ResizeObserver$Showside from "../utils/ResizeObserver.bs.js";
import * as ProductListItem$Showside from "./ProductListItem.bs.js";
import * as QuickViewButton$Showside from "./QuickViewButton.bs.js";
import * as ResizeObserver2$Showside from "../utils/ResizeObserver2.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as QuickViewOverlayButton$Showside from "./QuickViewOverlayButton.bs.js";
function QuickViewProductsOverlay$Stack(Props) {
  var pins = Props.pins;
  var fullscreenOpt = Props.fullscreen;
  var imageFitOpt = Props.imageFit;
  var activeOpt = Props.active;
  var visibilityOpt = Props.visibility;
  var enableButtonOpt = Props.enableButton;
  var productCardShapeOpt = Props.productCardShape;
  var buttonKindOpt = Props.buttonKind;
  var buttonText = Props.buttonText;
  var buttonTextColor = Props.buttonTextColor;
  var buttonBackgroundColor = Props.buttonBackgroundColor;
  var buttonIconLink = Props.buttonIconLink;
  var onClickOpt = Props.onClick;
  var highlightProductRef = Props.highlightProductRef;
  var margin = Props.margin;
  var buttonMargin = Props.buttonMargin;
  var showStackOpt = Props.showStack;
  var showProductTooltipOpt = Props.showProductTooltip;
  var displayVariantByOpt = Props.displayVariantBy;
  var hideOutOfStockOpt = Props.hideOutOfStock;
  var imageFitToContainerOpt = Props.imageFitToContainer;
  var openLinkInNewTabOpt = Props.openLinkInNewTab;
  var onClickButton = Props.onClickButton;
  var onClickThumbnail = Props.onClickThumbnail;
  var canCollapse = Props.canCollapse;
  var fullscreen = fullscreenOpt !== undefined ? fullscreenOpt : false;
  var imageFit = imageFitOpt !== undefined ? imageFitOpt : /* Cover */1;
  var active = activeOpt !== undefined ? activeOpt : false;
  var visibility = visibilityOpt !== undefined ? visibilityOpt : /* AutoHide */0;
  var enableButton = enableButtonOpt !== undefined ? enableButtonOpt : true;
  var productCardShape = productCardShapeOpt !== undefined ? productCardShapeOpt : /* Square */1;
  var buttonKind = buttonKindOpt !== undefined ? buttonKindOpt : /* ViewProducts */2;
  var onClick = onClickOpt !== undefined ? onClickOpt : function (param) {};
  var showStack = showStackOpt !== undefined ? showStackOpt : true;
  var showProductTooltip = showProductTooltipOpt !== undefined ? showProductTooltipOpt : false;
  var displayVariantBy = displayVariantByOpt !== undefined ? displayVariantByOpt : /* FirstVariant */0;
  var hideOutOfStock = hideOutOfStockOpt !== undefined ? hideOutOfStockOpt : true;
  var imageFitToContainer = imageFitToContainerOpt !== undefined ? imageFitToContainerOpt : false;
  var openLinkInNewTab = openLinkInNewTabOpt !== undefined ? openLinkInNewTabOpt : false;
  var match = ViewportContext$Showside.use(undefined);
  var isMobile = match.isMobile;
  var match$1 = EntrypointContext$Showside.use(undefined);
  var trackEvent = match$1.trackEvent;
  var elRef = React.useRef(null);
  var bounds = ResizeObserver$Showside.useResizeObserver(undefined, elRef);
  var match$2 = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var clearExitTimeout = match$2.clearTimeout;
  var setExitTimeout = match$2.setTimeout;
  var match$3 = React.useState(function () {});
  var setHighlightedProduct = match$3[1];
  var highlightedProduct = match$3[0];
  React.useEffect(function () {
    if (highlightProductRef !== undefined) {
      highlightProductRef.current = function (product) {
        Curry._1(setHighlightedProduct, function (param) {
          return product;
        });
      };
      return function (param) {
        highlightProductRef.current = function (param) {};
      };
    }
  }, []);
  var maxThumbnails = Belt_Option.getWithDefault(Belt_Option.map(bounds, function (bounds) {
    return (bounds.height - 120 | 0) / 48 | 0;
  }), 1);
  var maxThumbnails$1 = maxThumbnails > 1 ? maxThumbnails : 1;
  var match$4 = React.useState(function () {
    return false;
  });
  var setMouseOver = match$4[1];
  var mouseOver = match$4[0];
  var match$5 = React.useState(function () {
    return false;
  });
  var setThumbnailsMouseOver = match$5[1];
  var thumbnailsMouseOver = match$5[0];
  var match$6 = React.useState(function () {
    return false;
  });
  var setIntroPlaying = match$6[1];
  React.useEffect(function () {
    var timeoutId = setTimeout(function (param) {
      if (active) {
        return Curry._1(setIntroPlaying, function (param) {
          return false;
        });
      }
    }, 4000);
    if (active) {
      Curry._1(setIntroPlaying, function (param) {
        return true;
      });
    }
    return function (param) {
      clearTimeout(timeoutId);
    };
  }, [active]);
  var pins$1 = Belt_Array.slice(pins, 0, maxThumbnails$1);
  var products = Belt_Array.map(pins$1, function (pin) {
    return pin.product;
  });
  var isVisible;
  switch (visibility) {
    case /* AutoHide */0:
      isVisible = match$6[0] || mouseOver;
      break;
    case /* AlwaysShow */1:
      isVisible = true;
      break;
    case /* ShowOnHover */2:
      isVisible = mouseOver;
      break;
    case /* AlwaysHide */3:
      isVisible = false;
      break;
  }
  var renderProductTooltip = function (pin) {
    var product = pin.product;
    var variant = Product$Showside.getInitialDisplayVariant(hideOutOfStock, pin.variantId, displayVariantBy, product);
    var widthPx = Math.max(Math.min(Belt_Option.mapWithDefault(bounds, 1000, function (bounds) {
      return bounds.width - 70 | 0;
    }), 320), 110);
    var style = {
      width: CSS$Showside.intToPx(widthPx)
    };
    var showProductTooltip$1 = showProductTooltip && widthPx > 160;
    var handleProductClick = function (product, variant) {
      Curry._2(onClickThumbnail, product, variant);
      Curry.app(trackEvent, ["Clicked In-Media Product Card", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    };
    if (showProductTooltip$1) {
      return React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["group-2-hover:opacity-100 group-2-hover:pointer-events-auto pointer-events-none opacity-0", "transition-opacity duration-250", "absolute left-13.5 top-0"])),
        style: style
      }, React.createElement("div", {
        className: CSS$Showside.prefix("bg-main ml-2 p-2.5 rounded-custom w-full h-full shadow-xl")
      }, React.createElement(ProductListItem$Showside.make, {
        product: product,
        variant: variant,
        shape: productCardShape,
        imageFitStrategy: imageFitToContainer ? /* Contain */2 : /* Cover */1,
        flushed: false,
        padding: false,
        hideOutOfStock: hideOutOfStock,
        onClick: handleProductClick,
        enableDataTestId: false,
        displayVariantBy: displayVariantBy
      })));
    } else {
      return null;
    }
  };
  var total = products.length;
  var renderThumbnails = function (param) {
    return Belt_Array.mapWithIndex(pins$1, function (i, p) {
      var product = p.product;
      var variant = Product$Showside.getInitialDisplayVariant(hideOutOfStock, p.variantId, displayVariantBy, product);
      var tilt = i - (total - (4 < maxThumbnails$1 ? 4 : maxThumbnails$1) | 0) | 0;
      var x = String(8 + (thumbnailsMouseOver ? 0 : (tilt > 0 ? tilt : 0) << 1) | 0);
      var y = String(8 + (thumbnailsMouseOver ? Math.imul(i, 48) : Math.imul(tilt > 0 ? tilt : 0, 3)) | 0);
      var angle = String(thumbnailsMouseOver ? 0 : Math.imul(tilt > 0 ? tilt : 0, 5));
      var imageSrc = Belt_Option.getWithDefault(Product$Showside.Media.getImageUrlWithPosterFallback(variant.media), "");
      var highlighted = highlightedProduct !== undefined ? product.id === highlightedProduct.id : false;
      return React.createElement("div", {
        key: product.id,
        className: CSS$Showside.prefix("absolute transition-transform duration-200 pointer-events-auto -m-4 p-4"),
        style: {
          transform: "translate(" + x + "px, " + y + "px) rotate(" + angle + "deg)"
        }
      }, React.createElement(QuickViewButton$Showside.make, {
        className: "swiper-no-swiping",
        onClick: function (e) {
          e.stopPropagation();
          e.preventDefault();
          Curry.app(trackEvent, ["Clicked Product Stack Thumbnail", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
          var isTopThumbnail = i === (total - 1 | 0);
          Curry._1(setThumbnailsMouseOver, function (param) {
            return true;
          });
          if (!isTopThumbnail || !isMobile || thumbnailsMouseOver || products.length === 1) {
            return Curry._2(onClickThumbnail, product, variant);
          }
        },
        children: React.createElement("div", {
          className: CSS$Showside.prefix(Cn.make(["group-2 relative transition-all transform duration-500 bg-white flex justify-center items-center shadow", (thumbnailsMouseOver || tilt === 0) && highlighted ? "scale-105" : "scale-100"])),
          style: {
            height: "40px",
            width: "40px"
          }
        }, React.createElement(SmartImg$Showside.Sized.make, {
          src: imageSrc,
          containerWidth: 40,
          containerHeight: 40,
          fit: imageFit,
          priority: 0,
          alt: p.product.name
        }), renderProductTooltip(p)),
        dataId: product.id,
        dataTestId: "qv-product-stack-item"
      }));
    });
  };
  var renderButton = function (param) {
    var onClick$1 = Belt_Option.getWithDefault(onClickButton, onClick);
    if (!enableButton) {
      return null;
    }
    var tmp = {
      kind: buttonKind,
      at: /* Card */0,
      size: /* Small */0,
      openLinkInNewTab: openLinkInNewTab,
      collapsed: !isVisible,
      isMobile: isMobile,
      onClick: onClick$1
    };
    if (buttonText !== undefined) {
      tmp.text = Caml_option.valFromOption(buttonText);
    }
    if (buttonTextColor !== undefined) {
      tmp.textColor = Caml_option.valFromOption(buttonTextColor);
    }
    if (buttonBackgroundColor !== undefined) {
      tmp.backgroundColor = Caml_option.valFromOption(buttonBackgroundColor);
    }
    if (buttonIconLink !== undefined) {
      tmp.iconLink = Caml_option.valFromOption(buttonIconLink);
    }
    if (buttonMargin !== undefined) {
      tmp.margin = Caml_option.valFromOption(buttonMargin);
    }
    if (canCollapse !== undefined) {
      tmp.canCollapse = Caml_option.valFromOption(canCollapse);
    }
    return React.createElement(QuickViewOverlayButton$Showside.make, tmp);
  };
  var margin$1 = Belt_Option.flatMap(margin, function (marginFn) {
    return Belt_Option.map(bounds, marginFn);
  });
  var tmp;
  if (showStack) {
    var tmp$1 = {};
    if (margin$1 !== undefined) {
      tmp$1.margin = margin$1;
    }
    tmp = React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["transition-opacity duration-200", isVisible ? "opacity-100" : "opacity-0"])),
      style: tmp$1,
      onMouseEnter: function (param) {
        if (!isMobile) {
          Curry._1(clearExitTimeout, undefined);
          return Curry._1(setThumbnailsMouseOver, function (param) {
            return true;
          });
        }
      },
      onMouseLeave: function (param) {
        if (!isMobile) {
          return setExitTimeout(function (param) {
            Curry._1(setThumbnailsMouseOver, function (param) {
              return false;
            });
          }, 1000);
        }
      }
    }, renderThumbnails(undefined));
  } else {
    tmp = null;
  }
  return React.createElement("div", {
    ref: ReactDOMUtils$Showside.Ref.domRef(elRef),
    className: CSS$Showside.prefix(Cn.make(["absolute top-0 left-0 right-0 bottom-0", fullscreen ? "pointer-events-none" : ""])),
    onClick: function (param) {
      Curry._1(onClick, undefined);
    },
    onMouseEnter: function (param) {
      Curry._1(setMouseOver, function (param) {
        return true;
      });
    },
    onMouseLeave: function (param) {
      Curry._1(setMouseOver, function (param) {
        return false;
      });
    }
  }, tmp, renderButton(undefined));
}
QuickViewProductsOverlay$Stack.displayName = "QuickViewProductsOverlay.Stack";
var Stack = {
  make: QuickViewProductsOverlay$Stack
};
function QuickViewProductsOverlay$Hotspots(Props) {
  var sizeOpt = Props.size;
  var dynamicTooltipWidthOpt = Props.dynamicTooltipWidth;
  var productCardShapeOpt = Props.productCardShape;
  var pins = Props.pins;
  var fitOpt = Props.fit;
  var widthOpt = Props.width;
  var heightOpt = Props.height;
  var pinScaleOpt = Props.pinScale;
  var fullscreenOpt = Props.fullscreen;
  var activeOpt = Props.active;
  var visibilityOpt = Props.visibility;
  var dotColor = Props.dotColor;
  var enableButtonOpt = Props.enableButton;
  var buttonText = Props.buttonText;
  var buttonTextColor = Props.buttonTextColor;
  var buttonBackgroundColor = Props.buttonBackgroundColor;
  var buttonIconLink = Props.buttonIconLink;
  var buttonKindOpt = Props.buttonKind;
  var dotStyle = Props.dotStyle;
  var buttonMargin = Props.buttonMargin;
  var classNameOpt = Props.className;
  var highlightProductRef = Props.highlightProductRef;
  var showPinsOpt = Props.showPins;
  var displayVariantByOpt = Props.displayVariantBy;
  var imageFitToContainerOpt = Props.imageFitToContainer;
  var openLinkInNewTabOpt = Props.openLinkInNewTab;
  var hideOutOfStockOpt = Props.hideOutOfStock;
  var renderPinWrapperOpt = Props.renderPinWrapper;
  var onClickOpt = Props.onClick;
  var onClickButton = Props.onClickButton;
  var onClickPin = Props.onClickPin;
  var canCollapse = Props.canCollapse;
  var size = sizeOpt !== undefined ? sizeOpt : /* Base */0;
  var dynamicTooltipWidth = dynamicTooltipWidthOpt !== undefined ? dynamicTooltipWidthOpt : false;
  var productCardShape = productCardShapeOpt !== undefined ? productCardShapeOpt : /* Square */1;
  var fit = fitOpt !== undefined ? fitOpt : "cover";
  var width = widthOpt !== undefined ? widthOpt : 0;
  var height = heightOpt !== undefined ? heightOpt : 0;
  var pinScale = pinScaleOpt !== undefined ? pinScaleOpt : 1.0;
  var fullscreen = fullscreenOpt !== undefined ? fullscreenOpt : false;
  var active = activeOpt !== undefined ? activeOpt : false;
  var visibility = visibilityOpt !== undefined ? visibilityOpt : /* AutoHide */0;
  var enableButton = enableButtonOpt !== undefined ? enableButtonOpt : true;
  var buttonKind = buttonKindOpt !== undefined ? buttonKindOpt : /* ViewProducts */2;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var showPins = showPinsOpt !== undefined ? showPinsOpt : true;
  var displayVariantBy = displayVariantByOpt !== undefined ? displayVariantByOpt : /* FirstVariant */0;
  var imageFitToContainer = imageFitToContainerOpt !== undefined ? imageFitToContainerOpt : false;
  var openLinkInNewTab = openLinkInNewTabOpt !== undefined ? openLinkInNewTabOpt : false;
  var hideOutOfStock = hideOutOfStockOpt !== undefined ? hideOutOfStockOpt : true;
  var renderPinWrapper = renderPinWrapperOpt !== undefined ? renderPinWrapperOpt : function (a, b) {
    return b;
  };
  var onClick = onClickOpt !== undefined ? onClickOpt : function (param) {};
  var match = ViewportContext$Showside.use(undefined);
  var isMobile = match.isMobile;
  var match$1 = EntrypointContext$Showside.use(undefined);
  var trackEvent = match$1.trackEvent;
  var ref = React.useRef(null);
  var match$2 = React.useState(function () {});
  var setHighlightedPin = match$2[1];
  var highlightedPin = match$2[0];
  React.useEffect(function () {
    if (highlightProductRef !== undefined) {
      highlightProductRef.current = function (product) {
        Curry._1(setHighlightedPin, function (param) {
          return product;
        });
      };
      return function (param) {
        highlightProductRef.current = function (param) {};
      };
    }
  }, []);
  var bounds = ResizeObserver2$Showside.useResizeObserver(ref);
  var match$3 = React.useState(function () {
    return false;
  });
  var setMouseOver = match$3[1];
  var mouseOver = match$3[0];
  var match$4 = React.useState(function () {
    return false;
  });
  var setPinsOn = match$4[1];
  var pinsOn = match$4[0];
  var match$5 = React.useState(function () {
    return false;
  });
  var setIntroPlaying = match$5[1];
  React.useEffect(function () {
    var timeoutId = active ? (Curry._1(setIntroPlaying, function (param) {
      return true;
    }), Caml_option.some(setTimeout(function (param) {
      Curry._1(setIntroPlaying, function (param) {
        return false;
      });
    }, 4000))) : undefined;
    return function (param) {
      Belt_Option.forEach(timeoutId, function (prim) {
        clearTimeout(prim);
      });
    };
  }, [active]);
  var renderPin = function (pin) {
    var highlighted = highlightedPin !== undefined ? pin.product.id === highlightedPin.id : undefined;
    if (bounds === undefined) {
      return null;
    }
    var tmp = {
      size: size,
      dynamicTooltipWidth: dynamicTooltipWidth,
      shape: productCardShape,
      pin: pin,
      onClick: onClickPin,
      scale: pinScale,
      bounds: bounds,
      highlighted: highlighted,
      enableTip: !isMobile,
      imageFitToContainer: imageFitToContainer,
      hideOutOfStock: hideOutOfStock,
      displayVariantBy: displayVariantBy,
      trackEvent: trackEvent,
      mediaWidth: width,
      mediaHeight: height,
      key: pin.id
    };
    if (dotColor !== undefined) {
      tmp.dotColor = Caml_option.valFromOption(dotColor);
    }
    if (dotStyle !== undefined) {
      tmp.dotStyle = Caml_option.valFromOption(dotStyle);
    }
    return Curry._2(renderPinWrapper, pin, React.createElement(ProductPin$Showside.make, tmp));
  };
  var isVisible;
  switch (visibility) {
    case /* AutoHide */0:
      isVisible = match$5[0] || mouseOver || pinsOn;
      break;
    case /* AlwaysShow */1:
      isVisible = true;
      break;
    case /* ShowOnHover */2:
      isVisible = mouseOver;
      break;
    case /* AlwaysHide */3:
      isVisible = false;
      break;
  }
  var renderButton = function (param) {
    var onClick$1 = Belt_Option.getWithDefault(onClickButton, onClick);
    if (!enableButton) {
      return null;
    }
    var tmp = {
      kind: buttonKind,
      at: /* Card */0,
      size: /* Small */0,
      openLinkInNewTab: openLinkInNewTab,
      collapsed: !isVisible,
      isMobile: isMobile,
      onClick: onClick$1
    };
    if (buttonText !== undefined) {
      tmp.text = Caml_option.valFromOption(buttonText);
    }
    if (buttonTextColor !== undefined) {
      tmp.textColor = Caml_option.valFromOption(buttonTextColor);
    }
    if (buttonBackgroundColor !== undefined) {
      tmp.backgroundColor = Caml_option.valFromOption(buttonBackgroundColor);
    }
    if (buttonIconLink !== undefined) {
      tmp.iconLink = Caml_option.valFromOption(buttonIconLink);
    }
    if (buttonMargin !== undefined) {
      tmp.margin = Caml_option.valFromOption(buttonMargin);
    }
    if (canCollapse !== undefined) {
      tmp.canCollapse = Caml_option.valFromOption(canCollapse);
    }
    return React.createElement(QuickViewOverlayButton$Showside.make, tmp);
  };
  var fitCalc = ObjectFitMath$Showside.fitAndPosition({
    width: Belt_Option.mapWithDefault(bounds, 0, function (s) {
      return s.width;
    }),
    height: Belt_Option.mapWithDefault(bounds, 0, function (s) {
      return s.height;
    })
  }, {
    width: width,
    height: height
  }, fit);
  var style = {
    height: "" + fitCalc.height.toString() + "px",
    width: "" + fitCalc.width.toString() + "px"
  };
  return React.createElement("div", {
    ref: ReactDOMUtils$Showside.Ref.domRef(ref),
    className: Cn.make([CSS$Showside.prefix("absolute top-0 left-0 w-full h-full"), fullscreen ? CSS$Showside.prefix("pointer-events-none") : "", className]),
    onClick: function (param) {
      if (fullscreen) {
        Curry._1(setPinsOn, function (on) {
          return !on;
        });
        if (pinsOn) {
          return Curry.app(trackEvent, ["Clicked Product Pins Tips Off", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
        } else {
          return Curry.app(trackEvent, ["Clicked Product Pins Tips On", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
        }
      }
    },
    onMouseEnter: function (param) {
      Curry._1(setMouseOver, function (param) {
        return true;
      });
    },
    onMouseLeave: function (param) {
      Curry._1(setMouseOver, function (param) {
        return false;
      });
    }
  }, showPins ? React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 transition-opacity duration-300", isVisible || isMobile ? "opacity-100" : "opacity-0"])),
    style: style
  }, Belt_Array.map(pins, renderPin)) : null, fullscreen ? null : renderButton(undefined));
}
QuickViewProductsOverlay$Hotspots.displayName = "QuickViewProductsOverlay.Hotspots";
var Hotspots = {
  make: QuickViewProductsOverlay$Hotspots
};
export { Stack, Hotspots };
/* react Not a pure module */